import API from '../utils/api';

export const PROCEDURES_GET = 'PROCEDURES_GET';
export const PROCEDURES_GET_SUCCESS = 'PROCEDURES_GET_SUCCESS';
export const PROCEDURES_GET_FAILED = 'PROCEDURES_GET_FAILED';

export const getProcedures = () => ({
    type: PROCEDURES_GET
});

export const getProceduresSuccess = (procedures) => ({
    type: PROCEDURES_GET_SUCCESS,
    procedures
});

export const getProceduresFailed = () => ({
    type: PROCEDURES_GET_FAILED
});

export const getProceduresApi = () => (dispatch) => {
    dispatch(getProcedures());

    return API.get('management/dental/procedures').then((res) => {
        if (res.status !== 200) {
            dispatch(getProceduresFailed());

            return;
        }

        res.json().then((json) => {
            dispatch(getProceduresSuccess(json.data));
        });
    });
};


/** WEBPACK FOOTER **
 ** ./src/actions/procedures.js
 **/